import { render, staticRenderFns } from "./my-task.vue?vue&type=template&id=22d98e83&scoped=true&"
import script from "./my-task.vue?vue&type=script&lang=js&"
export * from "./my-task.vue?vue&type=script&lang=js&"
import style0 from "./my-task.vue?vue&type=style&index=0&id=22d98e83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d98e83",
  null
  
)

export default component.exports